import type {
  OrderTableSettingsMutationKey,
  UseOrderTableSettingsParams,
} from '../types';

export const getOrderTableSettingsMutationKey = (
  params: UseOrderTableSettingsParams,
): OrderTableSettingsMutationKey => [
  'users',
  params,
  'orderTableSettings',
  'update',
];
